import { Checkbox, Radio, Form } from "antd"
import { useState, useEffect } from "react"

const RadioForm = (props) => {
    const { values, disabled = false, parent = "", tableLabel = "", inputType = "" } = props
    const options = Array.isArray(props.options) ? props.options : []
    const [readOnlyValue, setReadOnlyValue] = useState("")

    let currentValue = values?.[props.id] || ""

    useEffect(() => {
        if (disabled) {
            let actualValue = options.find(opt => opt.value === currentValue)
            setReadOnlyValue(actualValue?.label || currentValue)
        }
    }, [disabled, options, currentValue])

    return (
        <>
            {
                disabled ? <span>{readOnlyValue}</span>
                    :
                    <Form.Item label="" preserve={false} style={{ marginBottom: 0 }}>
                        <Radio.Group options={options} disabled={disabled} value={currentValue} onChange={(e) => { props.handleChange(props.id, e.target.value, props.documentId) }} />
                    </Form.Item>
            }
        </>
    )
}

export default RadioForm
